import { jsx as t } from "react/jsx-runtime";
import { InputLabelWrapper as c } from "../input-label-wrapper/InputLabelWrapper.component.js";
import { c as o } from "../../index-C3-ZVs5E.js";
import '../../assets/FieldReadonly.css';const m = "_record_1qq62_2", _ = "_label_1qq62_6", d = "_textContent_1qq62_9", e = {
  record: m,
  label: _,
  textContent: d
}, b = ({
  id: l,
  label: n = "",
  text: r,
  className: a,
  containerClassName: s
}) => /* @__PURE__ */ t(
  c,
  {
    id: l,
    labelText: n,
    className: o(e.label, a),
    containerClassName: o(e.record, s),
    children: /* @__PURE__ */ t("span", { className: e.textContent, children: r })
  }
);
export {
  b as FieldReadonly
};
